/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   floorplans selectors
 */

import { PropertyType } from '@zcode/enums'
import { memoizeSelector } from '@zcode/memoizers'
import type { FloorplanListing, Property } from '@zcode/state-type'

export const selectHasRoomPropertyType = memoizeSelector((floorplans: Property['floorplans']) => {
  if (!floorplans) {
    return false
  }

  return floorplans.some(
    ({ propertyType }) =>
      propertyType === PropertyType.SHARED_ROOM || propertyType === PropertyType.ROOM
  )
})

export const selectFirstFloorplanId = (floorplans: Property['floorplans']) => {
  if (!floorplans?.length) {
    return null
  }
  const sortedFloorplans = Array.from(floorplans).sort(
    (a, b) => a.bedrooms - b.bedrooms || (a.minPrice ?? 0) - (b.minPrice ?? 0)
  )

  const nonWaitListedFloorplan = sortedFloorplans.find((fp: Property) => !fp.waitlistEnabled)

  return nonWaitListedFloorplan?.listingId ?? sortedFloorplans[0].listingId
}

export const selectMatchingFloorplanIdByBedrooms = (
  floorplans: Property['floorplans'],
  filtersBedroom: readonly boolean[]
) => {
  if (!floorplans?.length) {
    return null
  }
  const sortedFloorplans = Array.from(floorplans).sort(
    (a, b) => a.bedrooms - b.bedrooms || (a.minPrice ?? 0) - (b.minPrice ?? 0)
  )

  let matchingFloorplan: FloorplanListing | undefined

  // eslint-disable-next-line no-unused-expressions
  sortedFloorplans?.some((fp) => {
    if (filtersBedroom?.[fp?.bedrooms]) {
      matchingFloorplan = fp
      return true
    }
    return !!matchingFloorplan
  })

  const nonWaitListedFloorplan = sortedFloorplans.find(
    (fp) => !fp.waitlistEnabled && filtersBedroom?.[fp?.bedrooms]
  )

  return nonWaitListedFloorplan?.listingId ?? matchingFloorplan?.listingId ?? null
}
